import { useState } from "react";
import Button from "../../../../../../../../components/Button";
import { Icon } from "../../../../../../../../components/Icon";
import ActivityModal from "../ActivityModal";

interface CreateActivityButtonProps {
  eventId?: string;
  projectId?: string;
  onSuccess?: (startDate: Date) => void;
  defaultStartDate?: string; // Format: YYYY-MM-DD
  defaultStartTime?: string; // Format: HH:mm
}

export default function CreateActivityButton({
  eventId,
  projectId,
  onSuccess,
  defaultStartDate,
  defaultStartTime,
}: CreateActivityButtonProps) {
  const [displayNewActivityModal, setDisplayNewActivityModal] = useState(false);

  return (
    <>
      <ActivityModal
        isOpen={displayNewActivityModal}
        onClose={() => setDisplayNewActivityModal(false)}
        eventId={eventId}
        projectId={projectId}
        onActivityCreated={onSuccess}
        defaultStartDate={defaultStartDate}
        defaultStartTime={defaultStartTime}
      />

      <Button
        variant="secondary"
        className="text-sm gap-2 items-center text-accent"
        onClick={() => setDisplayNewActivityModal(true)}
      >
        <Icon icon="general" className="w-4 h-4" />
        Créer une activité
      </Button>
    </>
  );
}
